const Main = () => import('@/views/Main.vue')

const businessRouter = {
    path: '/shoppingMall',
    name: 'shoppingMall',
    component: Main,
    icon: require(`@/assets/images/menu-icons/icon_business_20_20.png`),
    icon_active: require(`@/assets/images/menu-icons/icon_business_hover_20_20.png`),
    children: [
		
        {
            path: 'goodsMall',
            name: 'goodsMall',
            component: () => import('@/views/Malls/goodsMall.vue'),
            meta: {
                title: '商品管理',
                roles: ['waybill']
            }
        },
		{
		    path: 'goodsOrder',
		    name: 'goodsOrder',
		    component: () => import('@/views/Malls/goodsOrder.vue'),
		    meta: {
		        title: '商品订单管理',
		        roles: ['waybill']
		    }
		},
		],
    meta: {
        title: '积分商城',
        roles: ['business']
    }
}

export default businessRouter